import {splitReducer} from '@travel-frontend/split-io';
import {combineReducers} from 'redux';

import {uiStateReducer} from '@/redux/uiState/reducer';
import {v1Reducer} from '@/redux/v1/reducer';

export const reducer = combineReducers({
  v1: v1Reducer,
  ui: uiStateReducer,
  split: splitReducer,
});
